import React from "react";
import { cn } from "@/utils/helpers";
import SvgIcon, { SvgIconProps } from "./SvgIcon";
import styles from "../Svg.module.css";

export default function SvgIconBurger({
	className,
	...props
} : SvgIconProps) {
	return (
		<SvgIcon
			className={cn(styles.SvgIconBurger, className)}
			{...props}
		>
			<path d="M96.875 28C98.6009 28 100 29.3431 100 31C100 32.6569 98.6009 34 96.875 34H3.125C1.39911 34 0 32.6569 0 31C0 29.3431 1.39911 28 3.125 28H96.875Z" />
			<path d="M96.875 66C98.6009 66 100 67.3431 100 69C100 70.6569 98.6009 72 96.875 72H3.125C1.39911 72 0 70.6569 0 69C0 67.3431 1.39911 66 3.125 66H96.875Z" />
		</SvgIcon>
	)
}
